import ProfileShowPage from '../../../components/pages/mypages/ProfileShowPage.vue'

export default {
  components: {
    ProfileShowPage
  }
}
